import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

import { Button } from '../Button/Button';
import styles from './InfoBlock.styles.m.css';

export enum InfoBlockTypes {
  Page = 'page',
  Chat = 'chat',
  ChatWithPattern = 'chat-with-pattern',
  Modal = 'modal',
  Sidebar = 'sidebar',
}

interface IInfoBlockProps {
  readonly className?: string;
  readonly iconClassName?: string;
  readonly buttonClassName?: string;
  readonly descriptionClassName?: string;
  readonly type?: InfoBlockTypes;
  readonly title?: string;
  readonly descriptions?: (React.ReactNode | string)[];
  readonly image?: string;
  readonly buttonTitle?: string;
  readonly isLoading?: boolean;
  onClick?(): void;
}

export const InfoBlock: FC<PropsWithChildren<IInfoBlockProps>> = (props) => {
  const {
    className,
    iconClassName,
    buttonClassName,
    descriptionClassName,
    type = InfoBlockTypes.Chat,
    title = '',
    descriptions = [],
    image = null,
    buttonTitle = '',
    isLoading = false,
    children,
    onClick,
  } = props;
  const showButton = Boolean(buttonTitle && onClick);
  const containerClass = classNames(styles.container, styles[`type-${type}`], className);

  return (
    <div className={containerClass}>
      {image && (
        <img
          className={classNames(styles.image, iconClassName)}
          src={image}
          alt={title || ''}
          draggable="false"
        />
      )}

      {title && <h3 className={styles.title}>{title}</h3>}

      {descriptions.map((description, index) => (
        <p
          className={classNames(styles.description, descriptionClassName)}
          key={typeof description === 'string' ? description : index}
        >
          {description}
        </p>
      ))}

      {children}

      {showButton && (
        <Button
          className={classNames(styles.button, buttonClassName)}
          theme="primary"
          isLoading={isLoading}
          onClick={onClick}
        >
          {buttonTitle}
        </Button>
      )}
    </div>
  );
};
